import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { EducationDashboardComponent } from '../../pages/education-dashboard/education-dashboard.component';
import { GenericDashboardComponent } from '../../pages/generic-dashboard/generic-dashboard.component';

@Component({
  selector: 'app-conditional-dashboard',
  standalone: true,
  imports: [CommonModule, EducationDashboardComponent, GenericDashboardComponent],
  templateUrl: './conditional-dashboard.component.html',
  styleUrl: './conditional-dashboard.component.scss'
})
export class ConditionalDashboardComponent implements OnInit {
  isLoading: boolean = false;
  
  constructor(
    private commonService: CommonService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Show loader for generic flow
    if (this.isGenericFlow) {
      this.isLoading = true;
      // Simulate loading time (you can adjust this or remove if not needed)
      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
    }
  }

  /**
   * Single condition check for flow type
   * Returns true for generic flow, false for education flow
   */
  get isGenericFlow(): boolean {
    return this.commonService.isGenericFlowActive();
  }
}
